import axios from "axios";

// Ops-hub module access (docs/REVAMP_PLAN.md §4). Kept out of api.js on purpose.
const API_BASE = process.env.REACT_APP_API_URL || "";

// Single registry for module title / icon / description (Header, AppLauncher, Admin grid all read this).
export const MODULES = {
  reorder:     { id: "reorder",     title: "Reorder Tracker",              icon: "📦", desc: "PO coverage and vendor approvals." },
  ars:         { id: "ars",         title: "ARS Management",               icon: "📋", desc: "MBQ, blacklist and manual allocation." },
  wh_refill:   { id: "wh_refill",   title: "Regional WH Replenishment",    icon: "🚚", desc: "Refill regional warehouses from the main warehouse." },
  stock_reco:  { id: "stock_reco",  title: "Ginesys vs Vin Stock Reco",    icon: "⚖️", desc: "Daily e-com stock mismatches between Ginesys and Vinculum." },
  discount_verify: { id: "discount_verify", title: "Discount Verification", icon: "🏷️", desc: "Live marketplace discounts checked against the SochOne discount master." },
  ecom_otb:    { id: "ecom_otb",    title: "Ecom OTB",                     icon: "📊", desc: "Weekly open-to-buy by department and ASP slab." }, // 2026-10-24
  channel_profit: { id: "channel_profit", title: "Channel Profitability", icon: "⚖️", desc: "Keep or blacklist each style on each channel, from actual profit." }, // 2026-10-27
};
export const MODULE_ORDER = ["reorder", "ars", "wh_refill", "stock_reco", "discount_verify", "ecom_otb", "channel_profit"]; // 2026-10-24: + ecom_otb

// 2026-10-07 accounts: the signed-in user, shared by App/Header/Sidebar/AdminPortal (set by App.js AccountsBridge).
// 2026-10-12 remove-pin: accounts are the only sign-in; the PIN/accounts mode switch and the module-access matrix are gone.
let _acctUser = null;
export const setAccountsUser = (u) => { _acctUser = u || null; };
export const getAccountsUser = () => _acctUser;

export const getMyModules = () =>
  axios.get(`${API_BASE}/api/me/modules`, { withCredentials: true }).then((r) => r.data);
